import { z } from 'zod';
/**
 * Language code (ISO-639-1 lowercase) — closed catalog for Phase 1.
 *
 * SCRUM-25 phase A.1 — backs the `identity.users.language` column. Each
 * supported locale corresponds to an active i18n bundle on the frontend
 * (`@sparta/i18n`); extending the catalog therefore requires the FE bundle
 * to ship first. Adding a new entry here without a corresponding bundle
 * would let the API accept a language we cannot render — kept closed by
 * design.
 *
 * Extension procedure:
 *   1. Add the bundle to `@sparta/i18n`.
 *   2. Add the code here.
 *   3. Migration: data-only, optional (`language` is already TEXT in PG;
 *      no DB enum to ALTER).
 */
export const LANGUAGE_CODES = ['en', 'es', 'fr', 'de', 'ja', 'ru'];
export const languageCodeSchema = z
    .enum(LANGUAGE_CODES)
    .brand();
//# sourceMappingURL=language-code.js.map